import { IMeetingChangeset } from '../abstract-meeting-changeset';
import { IControlMeetingDetailsDTO } from '../../../api/control.dao';
import { IAttendeeDTO, IAttendeeOrganizationDTO } from '../../../api/attendees.dao';
import { AttendeeUpdatedInTheMeetingEventBody } from '../index';

type AttendeeUpdated = boolean;
export class AttendeeUpdatedInTheMeetingChangeset extends IMeetingChangeset<AttendeeUpdatedInTheMeetingEventBody> {
    public applyChangesToMeeting(meeting: Partial<IControlMeetingDetailsDTO>): Partial<IControlMeetingDetailsDTO> {
        for (const [orgRole, organizations] of Object.entries(meeting)) {

            if (!this.organizationRoleList.includes(orgRole)) continue;

            const attendeeUpdated = this.updateAttendeeInOrganizations(organizations as IAttendeeOrganizationDTO[]);

            if (attendeeUpdated) {
                return { [orgRole]: organizations };
            }
        }

        return {};
    }

    public getMeetingId(): number {
        return super.getChangeset().meetingId;
    }

    public get meetingAttendeeId(): number {
        return super.getChangeset().meetingAttendeeId;
    }

    private get organizationRoleList(): string[] {
        return ['hosts', 'participants', 'presenters', 'supports', 'registrants'];
    }

    private updateAttendeeInOrganizations(organizations: IAttendeeOrganizationDTO[]): AttendeeUpdated {
        for (const organization of organizations) {
            const attendeeIndex = organization.attendees.findIndex(attendee => Number(attendee.meetingAttendeeId) === this.meetingAttendeeId);

            if (attendeeIndex !== -1) {
                this.updateAttendee(organization.attendees[attendeeIndex]);
                return true;
            }
        }

        return false;
    }

    private updateAttendee(attendee: IAttendeeDTO): void {
        this.setAttendeeStatus(attendee);
        this.setAttendeeJoinMethod(attendee);
        this.setAttendeeIsLate(attendee);
        this.setAttendeeNotes(attendee);
        this.setAttendeeIssues(attendee);
    }

    private setAttendeeStatus(attendee: IAttendeeDTO): void {
        attendee.status = super.getChangeset().joinStatus;
    }

    private setAttendeeJoinMethod(attendee: IAttendeeDTO): void {
        attendee.joinMethod = super.getChangeset().joinMethod;
    }

    private setAttendeeIsLate(attendee: IAttendeeDTO): void {
        attendee.isLate = super.getChangeset().isLate;
    }

    private setAttendeeNotes(attendee: IAttendeeDTO): void {
        attendee.notes = super.getChangeset().meetingAttendeeNote;
    }

    private setAttendeeIssues(attendee: IAttendeeDTO): void {
        attendee.issues = super.getChangeset().issues;
    }
}
